import React from "react"
import { twMerge } from "tailwind-merge"

const ShiftsStatsCard: React.FC<{ title: string; number: string | number; textColor?: string }> = ({
	title,
	number,
	textColor = "text-black",
}) => (
	<div className="flex flex-1 flex-col rounded-lg border border-gray-200 bg-white p-4">
		<span className="text-sm font-medium text-gray-500">{title}</span>
		<span className={twMerge("mt-1 text-xl font-medium", textColor)}>{number}</span>
	</div>
)

export default ShiftsStatsCard
